"use client";

import { Hero } from "./hero";
import { Founding } from "./founding";
import { EarlyYears } from "./early-years";
import { PlatformDevelopment } from "./platform-development";
import { Scaling } from "./scaling";
import { EngineEvolution } from "./engine-evolution";
import { MilestoneMoments } from "./milestone-moments";
import { TechMilestones } from "./tech-milestones";
import { GlobalExpansion } from "./global-expansion";
import { IndustryRecognition } from "./industry-recognition";
import { OperationalExcellence } from "./operational-excellence";
import { LeadershipEvolution } from "./leadership-evolution";
import { ClientJourneyEvolution } from "./client-journey-evolution";
import { Innovation } from "./innovation";
import { Challenges } from "./challenges";
import { Roadmap } from "./roadmap";
import { Legacy } from "./legacy";
import { Reflection } from "./reflection";
import { ThankYou } from "./thank-you";
import { ContinueJourney } from "./continue-journey";

export function HistoryPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-crimson">
        <Founding />
      </div>
      <EarlyYears />
      <div className="bg-aurora-purple">
        <PlatformDevelopment />
      </div>
      <Scaling />
      <div className="bg-aurora-cyan">
        <EngineEvolution />
      </div>
      <MilestoneMoments />
      <div className="bg-aurora-emerald">
        <TechMilestones />
      </div>
      <GlobalExpansion />
      <div className="bg-aurora-amber">
        <IndustryRecognition />
      </div>
      <OperationalExcellence />
      <div className="bg-aurora-purple">
        <LeadershipEvolution />
      </div>
      <ClientJourneyEvolution />
      <div className="bg-aurora-cyan">
        <Innovation />
      </div>
      <Challenges />
      <div className="bg-aurora-emerald">
        <Roadmap />
      </div>
      <Legacy />
      <div className="bg-aurora-amber">
        <Reflection />
      </div>
      <ThankYou />
      <ContinueJourney />
    </>
  );
}
